import * as React from 'react';
import { Link } from "@tanstack/react-router";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/atoms/card";
import { Button } from "@/components/atoms/button";

export function EmptyBasket() {
  return (
    <div className="flex flex-col items-center justify-center loader-container p-8">
      <h1 className="text-3xl font-bold">Your basket is empty</h1>
      <div className="mt-4">
        Looks like you haven&lsquo;t added any items to your basket yet.
      </div>
      <Link className="mt-8" to="/"><Button>Continue Shopping</Button></Link>
    </div>
  );
} 